import styled from 'styled-components';
import { isContactCardURL } from 'utils/contactCards';

export const isStaticImageURL = (mediaUrl: string) =>
  mediaUrl.startsWith('http') && !isContactCardURL(mediaUrl);

const StyledStaticImage = styled.img`
  display: block;
  max-height: 300px;
  max-width: 100%;
`;

interface StaticImagePreviewProps {
  url: string;
}

const StaticImagePreview = ({ url }: StaticImagePreviewProps): JSX.Element => {
  return <StyledStaticImage alt="Image preview" src={url} />;
};

export default StaticImagePreview;
